import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text, Box } from 'wt-ui';
import { Trans } from 'react-i18next';
import ProductLayer from '../ProductLayer';

import heap from '../../containers/App/heap';

const fontSizeFromnColumns = (nColumns, toSubtract) => {
  if (nColumns <= 3) {
    return `${toSubtract ? 12 - toSubtract : 12}px`;
  }
  if (nColumns <= 5) {
    return `${toSubtract ? 12 - toSubtract : 12}px`;
  }
  return `${toSubtract ? 12 - toSubtract : 12}px`;
};

const UnderlyingBox = ({ nColumns, underlying, blink }) => {
  const [openLayer, setOpenLayer] = useState(false);
  const [bg, setBg] = useState(
    `rgba(${[underlying.color.r, underlying.color.g, underlying.color.b, underlying.color.a].join(',')});`,
  );

  useEffect(() => {
    if (blink) {
      setBg(`rgba(${[underlying.color.r, underlying.color.g, underlying.color.b, 1].join(',')});`);
    }
    setTimeout(() => {
      setBg(`rgba(${[underlying.color.r, underlying.color.g, underlying.color.b, underlying.color.a].join(',')});`);
    }, 700);
  }, [underlying]);

  return (
    <React.Fragment key={underlying.name}>
      <Box
        basis={`${(1 / nColumns) * 100}%`}
        pad="small"
        background={bg}
        style={{ border: '1px solid #fff', cursor: 'pointer' }}
        onClick={(e) => {
          e.preventDefault();
          heap.track('ClickUnderlying', { name: underlying.name });
          setOpenLayer(true);
        }}
        onMouseEnter={() => {
          setBg(`rgba(${[underlying.color.r, underlying.color.g, underlying.color.b, 1].join(',')});`);
        }}
        onMouseLeave={() => {
          setBg(`rgba(${[underlying.color.r, underlying.color.g, underlying.color.b, underlying.color.a].join(',')});`);
        }}
      >
        <Text color="#fff" size={fontSizeFromnColumns(nColumns)} margin={{ bottom: 'small' }}>
          <Trans>{underlying.name}</Trans>
        </Text>
        <Text color="#fff" size={fontSizeFromnColumns(nColumns, 2)} style={{ textAlign: 'right' }}>
          {underlying.chg}%
        </Text>
      </Box>
      {openLayer ? (
        <ProductLayer
          product={underlying}
          onEsc={(e) => {
            e.preventDefault();
            setOpenLayer(false);
          }}
          onClickOutside={() => setOpenLayer(false)}
        />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};
UnderlyingBox.propTypes = {
  nColumns: PropTypes.number.isRequired,
  underlying: PropTypes.shape({}).isRequired,
  blink: PropTypes.bool.isRequired,
};

export default UnderlyingBox;
